import { v } from "convex/values";
import {
  defineTableWithInternalControl,
  internalControl,
} from "../../../lib/shared/validators";

export const logisticsPaymentMethodType = v.union(
  v.literal("cash"),
  v.literal("bank_transfer"),
  v.literal("digital"),
  v.literal("other"),
);

export const validatorLogisticsPaymentMethod = v.object({
  name: v.string(),
  type: logisticsPaymentMethodType,
  description: v.optional(v.string()),
  instructions: v.optional(v.string()),
  bankName: v.optional(v.string()),
  accountNumber: v.optional(v.string()),
  accountHolder: v.optional(v.string()),
  accountType: v.optional(v.string()),
  digitalPaymentUrl: v.optional(v.string()),
  digitalPaymentProvider: v.optional(v.string()),
  requiresEvidence: v.boolean(),
  autoVerify: v.optional(v.boolean()),
  isDefault: v.optional(v.boolean()),
  sortOrder: v.optional(v.number()),
  internalControl,
});

export const logistics_payment_methods = defineTableWithInternalControl(
  validatorLogisticsPaymentMethod,
)
  .index("by_type", ["type"])
  .index("by_company_and_type", ["internalControl.companyId", "type"])
  .index("by_company_and_default", ["internalControl.companyId", "isDefault"]);
